'use client';

import dynamic from 'next/dynamic';

export const CountdownDemo = dynamic(() => import('./CountdownDemo'));
